export const TEMPLATE_PARAMTER_ITEM_INPUT_PROPS = [
    "description",
	"defaultValue",
	"displayName",
	"thumbnailImage",
	"maxValue",
	"minValue",
	"name",
	"optionsList",
	"step",
	"type",
]


export function SanitizeTemplateParameterInput(parameter){
    let newParam = {...parameter};
    let templateKeys = Object.keys(newParam);
    for(var i = 0; i< templateKeys.length; i++){
        if(!TEMPLATE_PARAMTER_ITEM_INPUT_PROPS.includes(templateKeys[i])){
            delete newParam[templateKeys[i]];
        }
    }
    return newParam;
}